import styled from 'styled-components';

export const Item = styled.li`
  display: flex;
  align-items: center;
  min-height: 1.75rem;
  justify-content: space-between;

  .close-icon-subtask {
    display: none;
  }

  &:hover {
    .close-icon-subtask {
      display: inline-block;
    }

    span {
      color: #40e5a0;
    }
  }
`;

export const LeftSide = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  width: 100%;
`;

export const Input = styled.input`
  outline: none;
  width: 15rem !important;
  padding: 2px 0 2px 2px;
  font-size: 0.70625rem;
  font-family: Sora;
  font-weight: 600;
  color: #585e66;
  line-height: 0.889375rem;
  border-radius: 0.25rem !important;
  border: 1px solid #a9aeb4;
  margin-left: 0.81rem;

  &:hover {
    border: 1px solid rgba(0, 0, 0, 0.87);
  }

  &:focus {
    border: 1px solid #40e5a0;
  }
`;

export const DivIcon = styled.div`
  svg {
    width: 0.9125rem;
    height: 0.588125rem;
    margin-right: 0.85rem;

    &:hover {
      path {
        stroke: #40e5a0;
      }
    }
    cursor: pointer;
  }
`;

export const Title = styled.span`
  display: flex;
  flex-wrap: wrap;
  cursor: pointer;
  width: 11.875rem;
  font-family: Sora;
  font-size: 0.70625rem;
  font-weight: 600;
  color: #585e66;
  line-height: 0.889375rem;

  margin-left: 0.81rem;
`;
export const RightSide = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

export const RightSideText = styled.span`
  font-family: 'Sora';
  font-style: normal;
  font-weight: 400;
  font-size: 0.75rem;
  line-height: 0.95rem;
  margin-left: 0.4rem;
  margin-right: 0.2rem;

  color: #7e858f;
`;

export const IconWrapper = styled.div`
  position: absolute;
  right: 1rem;

  svg {
    :hover {
      path {
        stroke: #eb5757;
      }
    }
  }
`;
